module.exports = __webpack_public_path__ + "fonts/Pretendard-ExtraLight.caca3ea.woff";